import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-documentation",
  "use": "icon-documentation-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-documentation\"><path d=\"M71.984 44.815H115.9L71.984 9.642zM16.094.05h63.875l47.906 38.37v76.74c0 3.392-1.682 6.645-4.677 9.044s-7.056 3.746-11.292 3.746H16.094c-4.236 0-8.297-1.347-11.292-3.746S.125 118.552.125 115.16V12.84C.125 5.742 7.23.05 16.094.05m71.86 102.32V89.58h-71.86v12.79zm23.952-25.58V64H16.094v12.79z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol